// extracted by mini-css-extract-plugin
export default {"container_buttons":"hero_container_buttons__u-10L","title":"hero_title__lnhrk","text":"hero_text__gwlDI","content_image":"hero_content_image__pv4fa","image":"hero_image__dhluD"};